import { BASE_ENDPOINT } from "../../../endpoint";

export const retrieveAllLoanService = async (
	token: string,
	pagination?: {
		page: string;
		perPage: string;
	},
	filter?: {
		status?: string[];
	},
) => {
	const params = new URLSearchParams();
	if (pagination?.page) {
		params.append("page", pagination.page);
	}
	if (pagination?.perPage) {
		params.append("perPage", pagination.perPage);
	}
	if (filter?.status) {
		filter.status.forEach((status) => {
			params.append("status", status);
		});
	}
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/loanmanagement/all/loan?${params.toString()}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			},
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
			throw new Error(res.message);
		}
		return res;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
